module.exports = "<ui-view>\n    <ul class=\"list-group\">\n        <li class=\"list-group-item\" ng-repeat=\"issue in $ctrl.issues track by issue.term_id\">\n            <a ui-sref=\".list({issueId: issue.term_id, name: issue.name})\">\n                {{issue.name | uppercase}}\n            </a>\n        </li>\n    </ul>\n</ui-view>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/apps/projectManager/projectManager.html
// module id = 557
// module chunks = 0